// extracted by mini-css-extract-plugin
export var root = "Zn+V";
export var rootIcon = "+VKv";